import {
  AppBar,
  Box,
  Button,
  Grid,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';

import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../Utils/routes.json';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useState } from 'react';
import KenCard from '../../../../global_components/KenCard';
import KenPopover from '../../../../Components/KenPopOver';
import KenDialogBox from '../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../global_components/KenSelect';
import { RiCheckFill, RiNotification3Line } from 'react-icons/ri';
import Kentable from '../../../../global_components/KenTable/kentable';
import { CheckBox, Message } from '@material-ui/icons';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../global_components/KenSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenAutoComplete from '../../../../global_components/KenAutoComplete/index';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment';
import ChatLayout from '../../components/ChatLayout';
import ChatInput from '../../components/ChatInput';
import KenGridEditable from '../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import '../../../../style/index.css';
import {
  getEvaluationDetailsData,
  getRevalData,
  postEvaluationDetailsData,
  postRetestData,
} from '../../../../Utils/apiServices';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KenButton from '../../../../global_components/KenButton';
import '../../../../style/index.css';

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'EVALUATION',
  },
];

export const facultyDropDown = [
  { title: 'Jane Coper', year: 1994 },
  { title: 'Wade warren', year: 1972 },
  { title: 'Jane Coper', year: 1974 },
  { title: 'Wade warren', year: 2008 },
  { title: 'Wade warren', year: 1957 },
];

const onToggleEditMode = (id) => {
  console.log('id', id);
};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;
  return <EditOutlined className="m-0" onClick={() => onToggleEditMode(id)} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { seating_plan, id } = row.row.values;

  // console.log({ eligibility_status });

  let classOfBtn;
  if (seating_plan === 'Generate') {
    classOfBtn = classes.Green;
  } else if (seating_plan === 'View / Edit') {
    classOfBtn = classes.Blue;
  } else {
    classOfBtn = classes.medium;
  }
  if (seating_plan === 'Generate') {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classOfBtn}
              to={`${routes.seatingPlan}/arrangement/${id}`}
            >
              Generate
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishGenerate}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              Publish
            </Button>
          </div>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classes.Blue}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              View / Edit
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishView}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              Publish
            </Button>
          </div>
        </Box>
      </>
    );
  }
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles((theme) => ({
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    height: '50px',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  titleCount: {
    color: '#F14B2D',
    fontSize: 12,
  },
  titleCountSpan: {
    color: '#F14B2D',
    fontSize: 12,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'rgba(241, 75, 45, 0.2)',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: '#c12002',
    '&:hover': {
      color: '#c12002',
      background: 'rgba(241, 75, 45, 0.2)',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: '#02ab4a',

    background: 'rgba(138, 245, 196,0.4)',

    borderRadius: '20px',
    fontSize: '10px',
    height: '25px',
    margin: '5px 5px',
    '&:hover': {
      background: 'rgba(138, 245, 196,0.4)',

      color: '#02ab4a',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: '#979797',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#F2994A',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
  {
    label: 'BBALIB106-World Cultures',
    value: 'BBALIB106-World Cultures',
  },
];

const selectOptionsFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsStatus = [
  {
    label: 'Select Date',
    value: '',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Under process',
    value: 'Under process',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '--Select--',
  },
  {
    label: 'Duration 1',
    value: '1',
  },
  {
    label: 'Duration 2',
    value: '2',
  },
];
const selectOptionsAllocatedFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];
const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        {children}
        <TableCell>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      {isExpanded && (
        <TableRow style={{ backgroundColor: 'aliceblue' }}>
          {expandComponent}
        </TableRow>
      )}
    </>
  );
};

const Revulation = () => {
  const [startDate, setStartDate] = useState('25-02-2022');
  const [startTime, setStartTime] = useState('10: 45');
  const [previous, setPrevious] = useState({});
  const [linkState, setLinkState] = useState('Link');
  const [examDate, setExamDate] = useState('');
  const [deadlineDate, setDeadlineDate] = useState('');

  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  const [selectValueDuration, setSelectValueDuration] = useState(
    selectOptionsDuration[0].value
  );
  const chatData = [
    {
      sender: true,
      message: `Hey, Could you please let me know which chapters I have to cover
    in UX/UI paper?`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
    {
      sender: false,
      message: `Hi Nandhini, you should include first 8 chapters in mid semester
      exam.`,
      profilePic: '',
      time: '3 days ago',
    },
    {
      sender: true,
      message: `Okay, Thank you gentleman!`,
      profilePic: 'https://ptetutorials.com/images/user-profile.png',
      time: '3 days ago',
    },
  ];
  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );
  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    setRows((state) => {
      return newData.map((row) => {
        if (row.id === id) {
          if (check === 'done') {
            row.isEditMode = true;
            const payload = [
              {
                id: row.id,
                status: row.status,
                retestDueDate: row.due_date,
                numberofDocuments: row.no_of_documents,
                documentStatus: row.document_submitted,
                examDate: row.exam_date,
                reason: row.reason,
              },
            ];
            postRetestData(payload)
              .then((res) => {
                if (res.success === 'true' || true) {
                  // alert(res.message);
                  row.isEditMode = false;
                  getRevalExamDetailsDataListing();
                }
                row.isEditMode = false;
              })
              .catch((err) => {
                console.log('Failed to add. Please try again.', err);
                row.isEditMode = false;
              });
          }
          if (check === 'edit') {
            return { ...row, isEditMode: !row.isEditMode };
          }
        }
        return row;
      });
    });
  };
  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  const onChange = (e, row) => {
    console.log('erow', e, row);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };
  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEdit(id, newRows);
  };
  const createData = (
    id,
    course,
    student,
    term,
    exam_type,
    previous_marks,
    document_submitted,
    no_of_documents,
    revaluation_due_date,
    status
    // saved
  ) => ({
    id,
    course,
    student,
    term,
    exam_type,
    previous_marks,
    document_submitted,
    no_of_documents,
    revaluation_due_date,
    status,
    // saved,
  });
  const [rows, setRows] = useState([]);
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCampus = (e) => {
    setSelectValueCourse(e.target.value);
  };

  const [selectValueStatus, setSelectValueStatus] = useState(
    selectOptionsStatus[0].value
  );

  const handleSelectChangeStatus = (e) => {
    setSelectValueStatus(e.target.value);
  };

  const [selectValueFaculty, setSelectValueFaculty] = useState(
    selectOptionsFaculty[0].value
  );
  const handleSelectChangeFaculty = (e) => {
    setSelectValueFaculty(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const selectOptionsAllocated = [
    {
      label: 'Completed',
      value: 'Completed',
    },
    {
      label: 'Pending',
      value: 'Pending',
    },
  ];

  const selectOptionsAllocated1 = [
    {
      label: 'Submitted',
      value: 'Submitted',
    },
    {
      label: 'Not Submitted',
      value: 'Not Submitted',
    },
  ];

  const [selectValueAllocated, setSelectValueAllocated] = useState(
    selectOptionsAllocated[0].value
  );

  const handleSelectChangeAllocated = (e) => {
    setSelectValueAllocated(e.target.value);
  };

  const [selectValueAlloctedFaculty, setSelectValueAlloctedFaculty] = useState(
    selectOptionsAllocatedFaculty[0].value
  );

  const handleSelectChangeAlloctedFaculty = (e) => {
    setSelectValueAlloctedFaculty(e.target.value);
  };

  const handleSelectChangeDuration = (e) => {
    setSelectValueDuration(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  const manageExamDate = (e, row) => {
    setExamDate(e.target.value);
  };

  const manageDeadLineDate = (e, row) => {
    setDeadlineDate(e.target.value);
  };

  const manageStartTime = (e, row) => {
    setStartTime(e.target.value);
  };
  const venueCell = (row) => {
    // const { num } = row.row.values;
    return (
      <Box>
        <KenSelect
          name="faculty"
          options={facultyDropDown}
          value={facultyDrop.faculty}
          dropdownColor="#ffffff"
          onChange={(e, row) =>
            setFacultyDrop({
              ...facultyDrop,
              [e.target.name]: e.target.value,
            })
          }
          required={true}
        />
      </Box>
    );
  };

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [isView, setIsView] = useState(false);
  const [messageDialog, setMessageDialog] = useState(false);
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const handleClickOnView = () => {
    setIsView(true);
  };

  const DataWithLimit = rows.slice(0, 2);

  // const onDataSave = () => {
  //   console.log('object');
  //   const newData = [...rows];

  //   const payload = newData.map((row) => {
  //     console.log('rowrowrowrowrowrowrowrow', row);
  //     return {
  //       id: row.id,
  //       allocatedTo: row.allocatedTo,
  //       deadline: row.deadline,
  //       status: row.status,
  //     };
  //   });
  //   console.log('selectValueAllocated', selectValueAllocated);
  //   console.log('payloadpayloadpayloadpayload', payload);
  //   postEvaluationDetailsData(payload)
  //     .then((res) => {
  //       console.log('res', res);
  //       getEvaluationDetailsDataListing();
  //     })
  //     .catch((err) => {
  //       console.log('errerrerrerrerrerr', err);
  //       alert('Failed to add. Please try again.');
  //     });
  // };

  const getRevalExamDetailsDataListing = () => {
    getRevalData().then((res) => {
      console.log('resForStudentStatus', res);
      const ReTestDetailsInfo =
        res === null
          ? []
          : res.map((item, index) => {
              console.log('itemitemforRestest', item);
              return {
                id: item.id ? item.id : '',
                course: item.courseName ? item.courseName : '',
                student: item.studentName ? item.studentName : '',
                term: item.termName ? item.termName : '',
                exam_type: item.examType ? item.examType : '',
                previous_marks: item.previousMarks ? item.previousMarks : '',
                document_submitted: item.documentStatus
                  ? item.documentStatus
                  : '',
                no_of_documents: item.numberofDocuments
                  ? item.numberofDocuments
                  : '',
                revaluation_due_date: item.revalDueDate
                  ? item.revalDueDate
                  : '',
                status: item.status ? item.status : '',
                reason: item.reason ? item.reason : '',
              };
            });

      setRows(ReTestDetailsInfo);
      setFilterDialog(false);
    });
  };
  useEffect(() => {
    getRevalExamDetailsDataListing();
  }, []);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Revaluation
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<RiNotification3Line />}
              variant="contained"
              component={Link}
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              to={`${routes.invigilationProctoringNotification}`}
            >
              Notification
            </Button> */}
            {
              <Typography variant="h1" className={classes.titleCount}>
                <span className={classes.titleCountSpan}>Count</span> :{' '}
                {rows.length}
              </Typography>
            }
          </Grid>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            <KenButton
              label="View All"
              variant="outlined"
              color="primary"
              onClick={handleClickOnView}
            />
          </Grid>
        </Toolbar>
      </AppBar>

      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="center">
                  COURSE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="center">
                  STUDENT
                </TableCell>
                <TableCell className="tableHeaderTitle" align="center">
                  TERM{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="center">
                  EXAM MODE
                </TableCell>
                <TableCell className="tableHeaderTitle" align="center">
                  PREVIOUS MARKS
                </TableCell>

                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {isView
                ? rows.map((row) => {
                    console.log('hsdajkhsakjd', { row });
                    const SetDateFormat = {
                      ...row,
                      examDate: moment(row.dateTimeofExam).format(
                        'YYYY-MM-DD HH:mm'
                      ),
                    };
                    {
                      console.log('rowrowrowrowrow111111111', row);
                    }
                    return (
                      // <TableRow className="editableTableRowData" key={row.id}>
                      <ExpandableTableRow
                        key={row.id}
                        expandComponent={
                          <TableCell className="testForCol" colSpan="10">
                            <Table>
                              <TableRow>
                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  DOCUMENT SUBMITTED
                                </TableCell>

                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  NO. OF DOCUMENTS
                                </TableCell>

                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  DUE DATE
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle centerStatusTitle"
                                  align="left"
                                >
                                  REVALUATION STATUS
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle centerStatusTitle"
                                  align="left"
                                >
                                  REASON
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  EDIT
                                </TableCell>
                              </TableRow>

                              <TableBody className="tablebody">
                                <KenGridEditable
                                  {...{
                                    row: SetDateFormat,
                                    onChange,
                                    columns: [
                                      {
                                        column_name: 'document_submitted',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenSelect',
                                        dropdown: selectOptionsAllocated1,
                                      },
                                      {
                                        column_name: 'no_of_documents',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenInput',
                                        dropdown: selectOptionsAllocated,
                                      },

                                      // {
                                      //   column_name: 'allocatedTo',
                                      //   is_inline_edit: true,
                                      //   inline_edit_type: 'kenSelect',
                                      //   dropdown: selectOptionsAllocated,
                                      //   label: 'allocatedTo',
                                      //   onChange: handleSelectChangeAllocated,
                                      // },
                                      {
                                        column_name: 'revaluation_due_date',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenDatePicker',
                                        label: '',
                                      },
                                      {
                                        column_name: 'status',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenSelect',
                                        dropdown: selectOptionsAllocated,
                                        // label: 'eligibility_status',
                                        // style: 'red',
                                      },
                                      {
                                        column_name: 'reason',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenInput',
                                      },
                                    ],
                                  }}
                                />
                                <TableCell className={classes.selectTableCell}>
                                  {row.isEditMode ? (
                                    <>
                                      <IconButton
                                        aria-label="done"
                                        onClick={() =>
                                          onToggleEditMode('done', row.id)
                                        }
                                      >
                                        <DoneIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() => onRevert(row.id)}
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        onToggleEditMode('edit', row.id)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                </TableCell>
                              </TableBody>
                            </Table>
                          </TableCell>
                        }
                      >
                        {console.log('rowformeval', row)}
                        <KenGridEditable
                          {...{
                            row: SetDateFormat,
                            onChange,
                            columns: [
                              {
                                column_name: 'course',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'course',
                              },

                              {
                                column_name: 'student',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'student',
                              },
                              {
                                column_name: 'term',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'term',
                              },
                              {
                                column_name: 'exam_type',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'exam_type',
                              },
                              {
                                column_name: 'previous_marks',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'previous_marks',
                              },
                            ],
                          }}
                        />
                        {/* {row.status === 'Under process' ? (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.error}
                              // to={`${routes.invigilationProctoring}/${id}`}
                            >
                              Under process
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.normal}
                              // to={`${routes.seatingPlan}/arrangement/${id}`}
                            >
                              Completed
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    )} */}

                        {/* <TableCell className={classes.selectTableCell}>
                          {row.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                onClick={() => onToggleEditMode('done', row.id)}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                onClick={() => onRevert(row.id)}
                              >
                                <RevertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              aria-label="delete"
                              onClick={() => onToggleEditMode('edit', row.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </TableCell> */}
                        {/* </TableRow> */}
                      </ExpandableTableRow>
                    );
                  })
                : DataWithLimit.map((row) => {
                    console.log('hsdajkhsakjd', { row });
                    const SetDateFormat = {
                      ...row,
                      examDate: moment(row.dateTimeofExam).format(
                        'YYYY-MM-DD HH:mm'
                      ),
                    };
                    {
                      console.log('rowrowrowrowrow111111111', row);
                    }
                    return (
                      // <TableRow className="editableTableRowData" key={row.id}>
                      <ExpandableTableRow
                        key={row.id}
                        expandComponent={
                          <TableCell className="testForCol" colSpan="10">
                            <Table>
                              <TableRow>
                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  DOCUMENT SUBMITTED
                                </TableCell>

                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  NO. OF DOCUMENTS
                                </TableCell>

                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  DUE DATE
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle centerStatusTitle"
                                  align="left"
                                >
                                  REVALUATION STATUS
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle centerStatusTitle"
                                  align="left"
                                >
                                  REASON
                                </TableCell>
                                <TableCell
                                  className="tableHeaderTitle"
                                  align="left"
                                >
                                  EDIT
                                </TableCell>
                              </TableRow>

                              <TableBody className="tablebody">
                                <KenGridEditable
                                  {...{
                                    row: SetDateFormat,
                                    onChange,
                                    columns: [
                                      {
                                        column_name: 'document_submitted',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenSelect',
                                        dropdown: selectOptionsAllocated1,
                                      },
                                      {
                                        column_name: 'no_of_documents',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenInput',
                                        dropdown: selectOptionsAllocated,
                                      },

                                      // {
                                      //   column_name: 'allocatedTo',
                                      //   is_inline_edit: true,
                                      //   inline_edit_type: 'kenSelect',
                                      //   dropdown: selectOptionsAllocated,
                                      //   label: 'allocatedTo',
                                      //   onChange: handleSelectChangeAllocated,
                                      // },
                                      {
                                        column_name: 'revaluation_due_date',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenDatePicker',
                                        label: '',
                                      },
                                      {
                                        column_name: 'status',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenSelect',
                                        dropdown: selectOptionsAllocated,
                                        // label: 'eligibility_status',
                                        // style: 'red',
                                      },
                                      {
                                        column_name: 'reason',
                                        is_inline_edit: true,
                                        inline_edit_type: 'kenInput',
                                      },
                                    ],
                                  }}
                                />
                                <TableCell className={classes.selectTableCell}>
                                  {row.isEditMode ? (
                                    <>
                                      <IconButton
                                        aria-label="done"
                                        onClick={() =>
                                          onToggleEditMode('done', row.id)
                                        }
                                      >
                                        <DoneIcon />
                                      </IconButton>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() => onRevert(row.id)}
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() =>
                                        onToggleEditMode('edit', row.id)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                </TableCell>
                              </TableBody>
                            </Table>
                          </TableCell>
                        }
                      >
                        {console.log('rowformeval', row)}
                        <KenGridEditable
                          {...{
                            row: SetDateFormat,
                            onChange,
                            columns: [
                              {
                                column_name: 'course',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'course',
                              },

                              {
                                column_name: 'student',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'student',
                              },
                              {
                                column_name: 'term',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'term',
                              },
                              {
                                column_name: 'exam_type',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'exam_type',
                              },
                              {
                                column_name: 'previous_marks',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'previous_marks',
                              },
                            ],
                          }}
                        />
                        {/* {row.status === 'Under process' ? (
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.error}
                            // to={`${routes.invigilationProctoring}/${id}`}
                          >
                            Under process
                          </Button>
                        </div>
                      </Box>
                    </TableCell>
                  ) : (
                    <TableCell className={classes.selectTableCell}>
                      <Box>
                        <div style={{ display: 'flex' }}>
                          <Button
                            variant="primary"
                            component={Link}
                            className={classes.normal}
                            // to={`${routes.seatingPlan}/arrangement/${id}`}
                          >
                            Completed
                          </Button>
                        </div>
                      </Box>
                    </TableCell>
                  )} */}

                        {/* <TableCell className={classes.selectTableCell}>
                        {row.isEditMode ? (
                          <>
                            <IconButton
                              aria-label="done"
                              onClick={() => onToggleEditMode('done', row.id)}
                            >
                              <DoneIcon />
                            </IconButton>
                            <IconButton
                              aria-label="revert"
                              onClick={() => onRevert(row.id)}
                            >
                              <RevertIcon />
                            </IconButton>
                          </>
                        ) : (
                          <IconButton
                            aria-label="delete"
                            onClick={() => onToggleEditMode('edit', row.id)}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </TableCell> */}
                        {/* </TableRow> */}
                      </ExpandableTableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </KenCard>
      </Box>

      {/* Filter Modal */}
      {/* <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        icon={<RiCheckFill />}
        maxWidth={'md'}
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getEvaluationDetailsDataListing()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectOptionsCourse}
              value={selectValueCourse}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject Faculty"
              options={selectOptionsFaculty}
              value={selectValueFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeFaculty}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Date of Exam"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Date of Exam"
              value={examDate}
              type="date"
              required={true}
              defaultValue={examDate}
              onChange={manageExamDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Deadline"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Deadline"
              value={deadlineDate}
              type="date"
              required={true}
              defaultValue={deadlineDate}
              onChange={manageDeadLineDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Allocated To"
              options={selectOptionsAllocatedFaculty}
              value={selectValueAlloctedFaculty}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeAlloctedFaculty}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsStatus}
              value={selectValueStatus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeStatus}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox> */}

      {/* Message Modal */}
      {/* <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox> */}
      {/* <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center ' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Jane Cooper'}
            </p>

            <p>A - 12345</p>
            <p>Campus 1</p>
            <p>Course 1</p>
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox> */}
    </Box>
  );
};

export default Revulation;
